<template>
  <footer style="z-index:9999; position: relative;">
    <section class="all-info">
      <article>
        <h4 style="margin-top: 0; font-size: 1.4rem; font-family: 'Playfair Display';">{{hotel.name}}</h4>
        <p>{{hotel.additional_details}}</p>
      </article>
      <article>
        <section class="additional_info">
          <h4 style="margin-top: 0; font-size: 1.4rem; font-family: 'Playfair Display';">Information</h4>
          <ul>
            <li>
              <map-pin></map-pin>
              <a target="_blank" :href="'http://maps.google.com/?q=' + hotel.address">{{hotel.address}}</a>
            </li>
            <li>
              <phone></phone>
              <a target="_blank" :href="'tel:' + hotel.phone_no">{{hotel.phone_no}}</a>
            </li>
            <li>
              <mail></mail>
              <a target="_blank" :href="'mailto:' + hotel.email">{{hotel.email}}</a>
            </li>
          </ul>
          <div v-if="enable_trip_advisor == `${true}`" id="TA_certificateOfExcellence313" class="TA_certificateOfExcellence">
            <ul style="display: flex; flex-wrap: wrap; align-items: center" id="itm1kZ" class="TA_links 7GeMESJnBa">
              <li v-for="adv in tripAdvisorsJson" :id="adv.id" class="W3UFvGIwK"><a target="_blank"
                                                                                    :href="adv.redirect_to">
                <img width="60px" height="60px" style="border-radius: 50%" :src="adv.img"
                     alt="TripAdvisor"
                     class="widCOEImg" id="CDSWIDCOELOGO"/></a></li>
            </ul>
          </div>
        </section>
      </article>
      <article>
        <a :href="`https://www.google.com/maps?saddr=My+Location&daddr=${hotel.latitude},${hotel.longitude}`"
           target="_blank">
          <gmap-map :title="hotel.name + 'Map'" :center="{lat:latitude, lng:longitude}" :zoom="14" map-type-id="terrain"
                    style="height: 300px">
            <gmap-marker :position="{lat:latitude, lng:longitude}" :clickable="true"></gmap-marker>
          </gmap-map>
        </a>
        <p v-if="!!social_links.facebook || !!social_links.twitter || !!social_links.pinterest" style="margin: 0; text-align: right">Follow us on:</p>
        <section class="social-icons">
          <a v-if="!!social_links.facebook" :href="social_links.facebook">
            <facebook></facebook>
          </a>
          <a v-if="!!social_links.instagram" :href="social_links.instagram">
            <instagram></instagram>
          </a>
          <a v-if="!!social_links.twitter" :href="social_links.twitter">
            <twitter></twitter>
          </a>
          <a v-if="!!social_links.pinterest" :href="social_links.pinterest">
            <pinterest></pinterest>
          </a>
        </section>
      </article>
    </section>
    <section class="statements" v-if="web_config">
      <span style="padding: 0 10px" v-if="web_config.copyright_text">{{ web_config.copyright_text }}</span>
      <span style="margin: 0 5px;"
            v-if="(web_config.web_accessibility_statement && web_config.copyright_text) || (web_config.copyright_text && web_config.privacy_policy)">|</span>
      <img src="@/assets/static/access.png" alt="" style="width:20px;height:20px;"
           v-if="web_config.web_accessibility_statement">
      <a @click="w_a_statement = true" v-if="web_config.web_accessibility_statement">Web Accessibility Statement</a>
      <span style="margin: 0 5px;" v-if="web_config.web_accessibility_statement && web_config.privacy_policy">|</span>
      <a @click="other_statement = true" v-if="web_config.privacy_policy">Privacy Policy</a>
      <section class="statement" v-show="w_a_statement">
        <div>
          <figure class="pp_header">
            <img :src="hotel.business_logo" @click="w_a_statement = false" width="70px" style="cursor: pointer;"
                 :alt="`${hotel.name} Logo`">
            <h4>{{hotel.name}}</h4>
          </figure>
          <article class="pp_content">
            <h4>Web Accesibility Statement</h4>
            <p style="white-space: pre-wrap;">{{web_config.web_accessibility_statement}}</p>
          </article>
          <div class="pp_footer">
            <button style="margin: 0 auto;" :style="{'background-color': bookingColor}" class="blue-btn"
                    @click="w_a_statement = false">CLOSE
            </button>
          </div>
        </div>
      </section>
      <section class="statement" v-show="other_statement">
        <div>
          <figure class="pp_header">
            <img :src="hotel.business_logo" @click="other_statement = false" style="cursor: pointer;" width="70px"
                 :alt="`${hotel.name} Logo`">
            <h4>{{hotel.name}}</h4>
          </figure>
          <article class="pp_content">
            <h4>Privacy Policy</h4>
            <p style="white-space: pre-wrap;">{{web_config.privacy_policy}}</p>
          </article>
          <div class="pp_footer">
            <button style="margin:0 auto;" :style="{'background-color': bookingColor}" class="blue-btn"
                    @click="other_statement = false">CLOSE
            </button>
          </div>
        </div>
      </section>
    </section>
  </footer>
</template>

<script>
  import {Facebook, Twitter, Instagram, MapPin, Phone, Mail, User, Pi} from 'vue-feather-icon';
  import Pinterest from '@/components/general/pinterest-icon.vue';
  import tripAdvisorsJson from './../../assets/trip-advisors'

  export default {
    name: "theme-footer",
    components: {
      Facebook: Facebook.default,
      Twitter: Twitter.default,
      Instagram: Instagram.default,
      MapPin: MapPin.default,
      Phone: Phone.default,
      User: User.default,
      Mail: Mail.default,
      Pinterest
    },
    data() {
      return {
        mobile_nav: false,
        w_a_statement: false,
        other_statement: false,
        tripAdvisorsJson: tripAdvisorsJson,
        enable_trip_advisor: process.env.VUE_APP_ENABLE_TRIP_ADVISOR
      }
    },
    computed: {
      social_links() {
        console.log(this.web_config);
        return {
          facebook: !!this.web_config && this.web_config.facebook_url || '',
          twitter: !!this.web_config && this.web_config.twitter_url || '',
          pinterest: !!this.web_config && this.web_config.pinterest_url || '',
          instagram: !!this.web_config && this.web_config.instagram_url || ''
        }
      },
      hotel() {
        return this.$store.state.hotel;
      },
      web_config() {
        return !!this.hotel && this.$store.state.web_config;
      },
      master_config() {
        return !!this.$store.state.web_config.is_master && this.$store.state.web_config.is_master || false;
      },
      latitude() {
        return parseFloat(this.$store.state.hotel.latitude);
      },
      longitude() {
        return parseFloat(this.$store.state.hotel.longitude);
      },
      bookingColor() {
        return this.web_config.color_code
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~mixins';
  @import '~css_vars';

  article, figure {
    margin: 0;
    padding: 0;
  }

  footer {
    background-color: black;
    color: white;
    padding: 4rem 2rem 1rem 2rem;
    font-size: 10pt;
    margin-top: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .all-info {
      display: flex;
      align-items: flex-start;

      > div {
        flex: 1;
      }

      > :nth-child(2) {
        margin: 0 3rem;
        display: flex;
        justify-content: space-evenly;
        flex-direction: column;
      }

      @include media('<=tablet') {
        flex-direction: column;
      }
    }


    .additional_info {
      ul {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 15px;

        li {
          margin: 0;

          svg {
            min-width: 24px;
          }

          a {
            border: none;
            font-size: 12px;
          }
        }
      }
    }

    .social-icons {
      justify-content: space-around;

      a {
        width: 60px;
        height: 60px;
        border: 2px solid white;
        border-radius: 50%;

        svg {
          width: 40px;
          height: 40px;
          margin-right: 0;
        }
      }
    }

    .statements {
      margin-top: 30px;
    }
  }

  @include media('<=tablet') {
    footer {
      z-index: unset !important;
    }
  }


  @include media('<=phone') {
    footer {
      .additional_info {
        ul {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .social-icons {
        flex-wrap: nowrap;
      }
    }
  }
</style>
